import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import Modal from "../../common/Modal/Modal";
import { respondToInvoice } from "../../../actions/invoices";
import Addfiles from "../../common/Addfiles";
import { BRAND_NAME } from "../../../brand";


export function InvoiceModalToAdjudication(props) {

const [includeNotes, setIncludeNotes] = useState(false);
const [notes, setNotes] = useState(null);

const invoice = useSelector(state => state.invoices.invoice);
const messages = useSelector(state => state.messages);

const handleAdjudicate = (e) => {
    e.preventDefault();
    props.handleResponseSubmit({ stage: "AI", notes: notes }, "Invoice pushed to Adjudication");
}

useEffect(() => {
    // wait for server response, if update was successful, close modal
    if (messages.length > 0) {
        const lastIndex = messages.length - 1;
        messages[lastIndex].success && props.setRejModalOpen(false);
    }
}, [messages]);

const toggleIncludeNotes = (e) => {
    e.preventDefault();
    if (includeNotes) {
        notes && setNotes(null);
        setIncludeNotes(false);
    } else {
        setIncludeNotes(true);
    }
}

const handleCancel = (e) => {
    e.preventDefault();
    props.setRejModalOpen(false)
}

    return (
        <div>
            <Modal 
                blurBack={true}
                hideLogo={true}
                hasCloseButton={true}
                handleClose={() => props.setRejModalOpen(false)}
            >
                <div className="modal-content">
                    <h1 className="title t-center heavy gap-below-l">Initiating Adjudication</h1>
                    <p className="content1 light-black multiline gap-below-m">&nbsp;&nbsp;&nbsp;&nbsp;Adjudication is the last resort for resolving invoice disagreements. We encourage you to reach out directly to the Purchaser before proceeding, in case any misunderstanding can be resolved.</p>
                    <p className="content1 light-black multiline gap-below-m">&nbsp;&nbsp;&nbsp;&nbsp;Pursuing adjudication is the responsibility of the Vendor. Proceeding to the "Adjudication" stage via {BRAND_NAME} simply notifies the Purchaser of your intent to pursue adjudication, and marks the status of the invoice for your record and that of the Purchaser.</p>
                    <p className="title2 t-center heavy multiline gap-below-s">Do you want to initiate Adjudication?</p>
                    <form className="form" onSubmit={(e) => handleAdjudicate(e)}>	
                        <div >
                            <Addfiles 
                                uploadTitle="+ Add Supporting Docs"
                                selectedFiles={props.selectedFilesAdditional}
                                handleDrop={props.handleDrop}
                                removeSelectedFile={props.removeSelectedFile}
                                // removeUploadedFile={removeUploadedFileInvoiceAdditional}
                                // removedFiles={removedFilesInvoiceAdditional}
                                maxSize={10485760}
                                maxFiles={0}
                                multiple={true}
                                accept=""
                                textStyle="content2 tb-text"
                            />
                        </div>
                        <button 
                            id = "adj_notes"
                            style={{width: "max-content"}}
                            className={includeNotes ? "content2 light gap-below-xs" : "content2 tb-text"} 
                            onClick={(e) => {
                                e.preventDefault();
                                toggleIncludeNotes(e);
                            }}
                        >	
                        {includeNotes ? "- Remove Notes" : "+ Include Notes"}
                        </button>
                        {includeNotes &&
                        <div className="inputs-wrapper gap-below-s">
                            <div className="input-basic textarea ">	
                                <label htmlFor="email">Reason for Adjudication</label>			
                                <textarea
                                    type="text"
                                    name="notes"
                                    onChange={(e) => setNotes(e.target.value)}
                                    id="notes"
                                    rows="3"
                                    required
                                />
                                
                            </div>
                        </div>}
                        <div className="gap-above-m flex-row w100"> 
                            <button id="adj_initiate" className="btn tb iblock expand gap-right-s" type="submit" disabled={props.isSubmitting} >{props.isSubmitting ? "Please wait..." : "Initiate"}</button>
                            <button className="btn sec iblock expand" disabled={props.isSubmitting} onClick={(e) => handleCancel(e)} >Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {respondToInvoice})(InvoiceModalToAdjudication);

